import { isEnvProduction } from './app.helpers'

const packageJson = require('../../package.json')

export function logger(value) {
  if (isEnvProduction()) return
  console.log(value)
}

export function logAppVersion() {
  console.log(`App Version is ${packageJson.version}`)
}
